/* eslint-disable vue/valid-v-model */
<!--
 * @Description: 站点管理
 * @Autor: wangwangwang
 * @Date: 2021-01-30 14:08:50
 * @LastEditors: 刘小二
 * @LastEditTime: 2024-04-19 14:09:22
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div
              :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }"
            >
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">站点编码</span>
                <el-input
                  v-model="tableParam.code"
                  style="width: 150px"
                  clearable
                  placeholder="请输入"
                  @keyup.enter.native="gettableData()"
                />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">站点名称</span>
                <el-input
                  v-model="tableParam.stationName"
                  style="width: 150px"
                  clearable
                  placeholder="请输入"
                  @keyup.enter.native="gettableData()"
                />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">公司名称</span>
                <el-input
                  v-model="tableParam.company"
                  style="width: 150px"
                  clearable
                  placeholder="请输入"
                  @keyup.enter.native="gettableData()"
                />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">负责人</span>
                <el-input
                  v-model="tableParam.principalName"
                  style="width: 150px"
                  clearable
                  placeholder="请输入"
                  @keyup.enter.native="gettableData()"
                />
              </span>
              <el-button
                icon="el-icon-search"
                size="medium"
                class="bottom_all but1"
                @click="(tableParam.page = 1), gettableData()"
                >查 询</el-button
              >
              <el-button
                size="medium"
                class="bottom_all_two"
                style="margin-left: 12px"
                @click="init()"
                >重 置</el-button
              >
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button
                v-if="ButtonList.findIndex((res) => res.buttonValue == 'TIANJIA') !== -1"
                size="small"
                class="bottom_all"
                style="margin-left: 0"
                @click="addPoint()"
              >
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
              <el-button
                v-if="ButtonList.findIndex((res) => res.buttonValue == 'SHANCHU') !== -1"
                size="small"
                class="bottom_two"
                @click="Delete()"
              >
                <i
                  class="icon iconfont iconicon_button_delete"
                  style="font-size: 12px"
                ></i>
                删除
              </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link
                v-if="ButtonList.findIndex((res) => res.buttonValue == 'DAOCHU') !== -1"
                :underline="false"
                @click="load()"
              >
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>
                导出
              </el-link>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table
              :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }"
              border
              stripe
              style="width: 100%"
              :data="tableData"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
            >
              <el-table-column align="center" type="selection"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column
                  v-if="item.status"
                  :key="index2"
                  :label="item.label"
                  align="center"
                  :min-width="item.width"
                  :fixed="
                    item.label == '操作' ||
                    item.label == '生产线' ||
                    item.label == '使用仓' ||
                    item.label == '库存仓' ||
                    item.label == '浆水池'
                      ? 'right'
                      : false
                  "
                >
                  <template slot-scope="scope">
                    <span v-if="item.label == '外协单位理论日产能'">
                      <span
                        v-if="scope.row.outsourcingUnitCapacity == 0"
                        style="color: #969799"
                        >不满足委托需求</span
                      >
                      <span
                        v-if="scope.row.outsourcingUnitCapacity == 1"
                        style="color: #00a754"
                        >满足委托需求</span
                      >
                    </span>

                    <span v-else-if="item.label == '状态'">
                      <span v-if="scope.row.enable == 0" style="color: #969799"
                        >禁用</span
                      >
                      <span v-if="scope.row.enable == 1" style="color: #00a754"
                        >启用</span
                      >
                    </span>
                    <div v-else-if="item.label == '操作'" style="position: relative">
                      <el-dropdown :hide-on-click="false" trigger="click">
                        <el-button size="mini" class="bottom_one">更多</el-button>
                        <el-dropdown-menu slot="dropdown" style="text-align: left">
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="changeline(scope.row)"
                              >生产线维护</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="changeusewarehouse(scope.row)"
                              >使用仓维护</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="changewarehouse(scope.row)"
                              >库存仓维护</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="warehouseBind(scope.row)"
                              >使用仓绑定</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="dialog(scope.row)"
                              >浆水池维护</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="changeSite(scope.row)"
                              >地磅维护</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              size="mini"
                              style="margin: 5px 0"
                              class="bottom_one"
                              @click="changeStationMain(scope.row)"
                              >站点主体</el-button
                            >
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="ButtonList.some((res) => res.buttonValue == 'XIUGAI')"
                          >
                            <el-button
                              style="margin: 5px 0"
                              class="bottom_one"
                              size="mini"
                              @click="pagesupdateFromDate(scope.row, '修改')"
                            >
                              修改
                            </el-button>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <el-button
                              style="margin: 5px 0"
                              :disabled="!scope.row.wxAppId"
                              class="bottom_one"
                              size="mini"
                              @click="downQRCode(scope.row, '下载二维码')"
                            >
                              下载二维码
                            </el-button>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button
            size="mini"
            icon="el-icon-refresh-right"
            class="bottom_all_two"
            @click="gettableData"
            >刷新</el-button
          >
        </div>
      </div>
    </el-container>
    <!-- 添加 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="addDialog"
      width="720px"
      :close-on-click-modal="false"
      :before-close="resetFromDate"
    >
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form
          ref="reffromDate"
          :rules="rules"
          :inline="true"
          :model="fromDate"
          label-width="110px"
        >
          <el-form-item
            v-if="UserInfo.adminStatus == 1"
            prop="companyId"
            :rules="[{ required: true, message: '请选择公司', trigger: 'blur' }]"
          >
            <span slot="label" style="color: #ff0000">公司</span>
            <el-select
              ref="selection1"
              v-model="fromDate.companyId"
              @change="
                setstationIdlist(),
                  $nextTick(() => {
                    fromDate.company = $refs.selection1.selectedLabel;
                  })
              "
            >
              <el-option
                v-for="item in companylist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="stationId"
            :rules="[{ required: true, message: '请选择站点', trigger: 'blur' }]"
          >
            <span slot="label" style="color: #ff0000">站点名称</span>
            <el-select
              ref="selection2"
              v-model="fromDate.stationId"
              v-loading="stationLoad"
              @change="
                get_simple_organizationFun(fromDate.stationId),
                  $nextTick(() => {
                    fromDate.stationName = $refs.selection2.selectedLabel;
                  })
              "
            >
              <el-option
                v-for="item in stationIdlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="dailyCapacity" label-width="120px">
            <span slot="label">理论日产能(㎡)</span>
            <el-input
              v-model="fromDate.dailyCapacity"
              style="width: 190px"
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
              @input="fromDate.dailyCapacity = $regExp.checkNum(fromDate.dailyCapacity)"
              @blur="
                fromDate.dailyCapacity = $regExp.blurCheckNum(fromDate.dailyCapacity)
              "
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <span slot="label">站点编码</span>
            <el-input
              v-model="fromDate.code"
              placeholder="请输入"
              clearable
              :disabled="!!fromDate.id"
              @input="changecode('code')"
              @blur="barcodeBlur()"
            ></el-input>
          </el-form-item>
          <el-form-item prop="stationAddress">
            <span slot="label">站点地址</span>
            <el-input
              v-model="fromDate.stationAddress"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <div>
            <el-form-item>
              <span slot="label">地图选点</span>
              <div class="mapbutton ellipsis" @click="handleMapInit">
                {{ fromDate.reconnaissanceAddress }}
              </div>
            </el-form-item>
          </div>
          <el-form-item>
            <span slot="label">经度</span>
            <el-input v-model="fromDate.longitude" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">纬度</span>
            <el-input v-model="fromDate.dimensionality" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">电子围栏(千米)</span>
            <el-input
              v-model="fromDate.electronicFence"
              placeholder="请输入"
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
              @input="
                fromDate.electronicFence = $regExp.checkNum(fromDate.electronicFence)
              "
              @blur="
                fromDate.electronicFence = $regExp.blurCheckNum(fromDate.electronicFence)
              "
            ></el-input>
          </el-form-item>
          <el-form-item class="FZYplaceholder TabsWarp">
            <span slot="label">站长</span>
            <TreeSelect
              ref="principalName"
              v-model="fromDate.principalId0"
              :loadData="onLoadData"
              :placeholder="principalName"
              style="width: 200px; height: 36px; z-index: 100000"
              :tree-data="treeData"
              allowClear
              :replaceFields="{ title: 'name', value: 'id' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              treeNodeFilterProp="title"
              :getPopupContainer="
                (triggerNode) => {
                  return triggerNode.parentNode || document.body;
                }
              "
              @change="
                (fromDate.principalId = fromDate.principalId0),
                  $nextTick(() => {
                    fromDate.principalName = $refs.principalName.$el.innerText;
                  })
              "
            ></TreeSelect>
          </el-form-item>
          <el-form-item prop="stationPhone">
            <span slot="label">站点电话</span>
            <el-input v-model="fromDate.stationPhone" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">外协单位</span>
            <el-select
              v-model="fromDate.outsourcingUnitIds"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in outsourcingUnitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="fromDate.outsourcingUnitIds.length > 0"
            prop="outsourcingUnitCapacity"
            label-width="140px"
          >
            <span slot="label">外协单位理论日产能</span>
            <el-radio-group v-model="fromDate.outsourcingUnitCapacity">
              <el-radio label="1">满足委托要求</el-radio>
              <el-radio label="0">不满足委托要求</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label">试验单位</span>
            <el-input v-model="fromDate.testUnit" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="oddments">
            <span slot="label">余料判定量</span>
            <el-input
              v-model="fromDate.oddments"
              placeholder="请输入"
              onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
              @input="fromDate.oddments = $regExp.checkNum(fromDate.oddments)"
              @blur="fromDate.oddments = $regExp.blurCheckNum(fromDate.oddments)"
            >
              <template slot="append">方</template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="printOffset">
            <span slot="label">打印偏移</span>
            <el-input v-model="fromDate.printOffset" placeholder="请输入" type="number"> </el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button
          class="bottom_all"
          style="margin-left: 24px"
          @click="pagessubmitFromDate()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 地图选点 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="mapVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <span slot="title" class="dialog-title">地图选点</span>
      <div class="amap-page-container">
        <el-amap-search-box
          class="search-box"
          :search-option="searchOption"
          :on-search-result="onSearchResult"
        ></el-amap-search-box>
        <el-amap
          v-if="mapVisible"
          ref="amapManager"
          :zoom="zoom"
          :events="events"
          :center="mapCenter"
          :plugin="plugin"
          class="amap-demo"
        >
          <el-amap-marker
            :position="markers.position"
            :events="markers.events"
            :draggable="markers.draggable"
          ></el-amap-marker>
        </el-amap>
        <div class="toolbar">
          <span v-if="loaded">
            position: {{ markers.position }} address: {{ address }}
          </span>
          <span v-else>正在定位</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="mapVisible = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="savepoint()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 生产线维护 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="lineDialog"
      width="1100px"
      :close-on-click-modal="false"
      :before-close="resetOtherFromDate"
    >
      <span slot="title" class="dialog-title">生产线维护</span>
      <div style="padding-bottom: 10px">
        <el-button
          size="mini"
          class="bottom_all"
          style="margin-left: 0"
          @click="addline()"
        >
          <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
          添加
        </el-button>
      </div>
      <div class="dialoginfo">
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="lineList"
          tooltip-effect="dark"
        >
          <el-table-column label="生产线" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="编码" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.code"
                style="width: 100%"
                placeholder="请输入"
                clearable
                @blur="lineCodeValidate(scope.row.code, scope.$index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="生产线日产能" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.output"
                style="width: 100%"
                type="Number"
                placeholder="请输入"
                clearable
              >
                <template slot="append">方</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="库存仓" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.list"
                style="width: 100%"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in usewarehousearr"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="接料语音" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.voiceObj"
                value-key="id"
                style="width: 100%"
                placeholder="请选择"
                @change="(e) => selectVoice(e, scope.$index)"
              >
                <el-option
                  v-for="item in voiceList"
                  :key="item.id"
                  :label="item.itemName"
                  :value="item"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="吹灰口ip" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.accessControlIp"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="吹灰口编码" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.accessControlCode"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="Deleteline(scope.$index)">
                <i
                  class="icon iconfont iconicon_button_delete"
                  style="font-size: 12px"
                ></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveline"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 使用仓维护 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="usewarehouseDialog"
      width="900px"
      :close-on-click-modal="false"
      :before-close="resetOtherFromDate"
    >
      <span slot="title" class="dialog-title">使用仓维护</span>
      <div class="dialoginfo">
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="usewarehouseList"
          tooltip-effect="dark"
          height="500"
        >
          <el-table-column
            label="仓库名"
            align="center"
            prop="fixedName"
          ></el-table-column>
          <el-table-column label="使用仓" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="编码" align="center" prop="code"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveusewarehouse"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 使用仓库存仓绑定 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="warehouseBindDig"
      width="900px"
      :close-on-click-modal="false"
      :before-close="resetOtherFromDate"
    >
      <span slot="title" class="dialog-title">使用仓绑定</span>
      <div style="padding-bottom: 10px">
        <el-button
          size="mini"
          class="bottom_all"
          style="margin-left: 0"
          @click="addwarehouseBind()"
        >
          <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
          添加
        </el-button>
      </div>
      <div class="dialoginfo">
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="warehouseBindList"
          tooltip-effect="dark"
          height="500"
        >
          <el-table-column label="库存仓" align="center" prop="fixedName">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.warehouseId"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in warehouseList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="使用仓" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.useCode"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in usewarehouseList"
                  :key="index"
                  :label="item.fixedName"
                  :value="item.code"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="使用仓生产线" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.useLineId"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in lineList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="使用仓重命名" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.useAliasName"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="排序号" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.sortNum"
                style="width: 100%"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" prop="code">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="bottom_two"
                @click="deleteWarehouseBind(scope.$index)"
              >
                <i
                  class="icon iconfont iconicon_button_delete"
                  style="font-size: 12px"
                ></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">取 消</el-button>
        <el-button
          class="bottom_all"
          style="margin-left: 24px"
          @click="saveusewarehouseBind"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 库存仓维护 -->
    <el-dialog
      :visible.sync="warehouseDialog"
      width="80%"
      :close-on-click-modal="false"
      :before-close="resetOtherFromDate"
    >
      <span slot="title" class="dialog-title">库存仓维护</span>
      <div style="padding-bottom: 10px">
        <el-button
          size="mini"
          class="bottom_all"
          style="margin-left: 0"
          @click="addwarehouse()"
        >
          <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
          添加
        </el-button>
      </div>
      <div class="dialoginfo">
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="warehouseList"
          tooltip-effect="dark"
        >
          <!-- <el-table-column label="使用仓" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.codeList" style="width: 100%" multiple placeholder="请选择" @change="selectUseHouse($event, scope.$index)">
                <el-option v-for="(item, index) in useHouseList" :key="index" :label="item.newName" :value="item.newValue"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column label="库存仓" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="吹灰口编码" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.code"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="满仓量" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.stock"
                style="width: 100%"
                placeholder="请输入"
                clearable
                oninput="if(value.length > 11 ){ value = value.slice(0,11)}"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.stock = $regExp.checkNum(scope.row.stock)"
                @blur="scope.row.stock = $regExp.blurCheckNum(scope.row.stock)"
              >
                <template slot="append">吨</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="原物料" prop="rawName" align="center">
          </el-table-column>
          <el-table-column label="是否过磅显示" prop="weightShow" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.weightShow"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="排序号" prop="sortNum" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.sortNum"
                type="number"
                style="width: 100%"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="led编号" prop="ledNum" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ledNum" style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="bottom_two"
                @click="Deletewarehouse(scope.$index)"
              >
                <i
                  class="icon iconfont iconicon_button_delete"
                  style="font-size: 12px"
                ></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="savewarehouse"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 浆水池维护 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="Dialog1"
      width="580px"
      :close-on-click-modal="false"
      :before-close="resetOtherFromDate"
    >
      <span slot="title" class="dialog-title">浆水池维护</span>
      <div>
        <div style="padding-bottom: 10px">
          <el-button
            size="mini"
            class="bottom_all"
            style="margin-left: 0"
            @click="add1('添加')"
          >
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="arr1"
          tooltip-effect="dark"
        >
          <el-table-column label="浆水池" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.name"
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delete1(scope.$index)">
                <i
                  class="icon iconfont iconicon_button_delete"
                  style="font-size: 12px"
                ></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit1()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 站点主体 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="stationDialog"
      width="900px"
      :close-on-click-modal="false"
      :before-close="resetOtherFromDate"
    >
      <span slot="title" class="dialog-title">站点主体</span>
      <div>
        <div style="padding-bottom: 10px">
          <el-form
            ref="stationDate"
            :rules="rules"
            :inline="true"
            :model="stationfromaddDate"
            label-width="110px"
          >
            <el-form-item prop="stationId">
              <span slot="label">站点主体</span>
              <el-select v-model="stationfromaddDate.stationSubjectId" placeholder="选择">
                <el-option
                  v-for="item in companylist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="effectiveTime">
              <span slot="label">生效时间</span>
              <el-date-picker
                v-model="stationfromaddDate.effectiveTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
                clearable
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="printOffset">
              <el-button
                class="bottom_all"
                style="margin-left: 0"
                @click="addstations('添加')"
              >
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="stationList"
          tooltip-effect="dark"
        >
          <el-table-column label="站点名称" align="center">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.stationName }}</span> -->
              <el-input
                v-model="scope.row.stationName"
                disabled
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="站点主体" align="center" width="300px">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.stationSubject"
                disabled
                style="width: 100%"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="生效时间" align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.effectiveTime"
                disabled
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
                clearable
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="bottom_two"
                @click="deleteStation(scope.row.id)"
              >
                <i
                  class="icon iconfont iconicon_button_delete"
                  style="font-size: 12px"
                ></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="bottomclass">
          <div class="top_page_totle">总共{{ totalpage }}条</div>
          <el-pagination
            :page-size="stationfromDate.pageSize"
            :current-page.sync="stationfromDate.page"
            layout="prev,pager,next,jumper"
            :total="totalpage"
            @current-change="nextpage()"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">关 闭</el-button>
        <!-- <el-button class="bottom_all" style="margin-left: 24px" @click="confrimaddstation()">确 定</el-button> -->
      </span>
    </el-dialog>
    <siteMaintain ref="siteMaintain" :siteDialog.sync="siteDig"></siteMaintain>
  </div>
</template>
<script>
import { TreeSelect } from "ant-design-vue";
import mixin from "@/mixins/ICPSmixin.js";
import { getDicType } from "@/api/common.js";
import {
  queryPage,
  batchUpdateOrDelete,
  updateSortNum,
  saveOrUpdate,
  Download,
  warehousePage,
  warehousesaveOrUpdate,
  wareusehousePage,
  // queryListsByStationId,
  wareusehousesaveOrUpdate,
  // getusewarehousearr,
  getPLByStationId,
  saveOrUpdateProductLine,
  getListByPid,
  saveseriflux,
  stationQueryCode,
  getStationMain,
  addStationMain,
  queryWarehouseUse,
  saveWarehouseUse,
  // getStationWxacode,
} from "@/api/basicConfig/site.js";
import { queryPage as queryuserPage } from "@/api/basedata/user";
import { querysupplierPage } from "@/api/GHnumber/supplier.js";
import { getUserInfo } from "@/utils/auth.js";
import {
  orgUserTree,
  permissionsCompanyList,
  getUserAut,
  get_simple_organization,
  getPermissionsUserTree,
  getOrgznizationAndUsersTree,
} from "@/api/common.js";
import { get_station_list } from "@/api/smart/stocksake.js";
import { setTimeout } from "timers";
// import { siteMaintain } from "./components/siteMaintain";
export default {
  components: { TreeSelect, siteMaintain: () => import("./components/siteMaintain") },
  mixins: [mixin],
  data() {
    let _this = this;
    const reconnaissanceAddressrules = (rule, value, callback) => {
      if (value === "" || value == "请选择地图标点") {
        callback(new Error("请在地图上进行选点标记"));
      } else {
        callback();
      }
    };
    var landlinePhone = (rule, value, callback) => {
      if (value && !this.$regExp.landlinePhoneReg(value)) {
        return callback(new Error("电话格式错误！"));
      } else {
        callback();
      }
    };
    return {
      /*地磅维护开始*/
      siteDig: false,
      /*地磅维护结束*/
      TreeSelectStypeNumber: 0,
      treeData: [],
      UserInfo: "",
      companylist: [],
      stationIdlist: [],
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete,
      updateSortNum: updateSortNum,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "站点编码", width: "160", prop: "code", status: true },
        { label: "公司", width: "160", prop: "company", status: true },
        { label: "站点名称", width: "140", prop: "stationName", status: true },
        { label: "当前站点主体", width: "140", prop: "stationSubject", status: true },
        {
          label: "理论日产能",
          width: "120",
          prop: "dailyCapacity",
          status: true,
        },
        {
          label: "站点地址",
          width: "140",
          prop: "stationAddress",
          status: true,
        },
        {
          label: "外协单位",
          width: "160",
          prop: "outsourcingUnit",
          status: true,
        },
        {
          label: "余料判定量",
          width: "160",
          prop: "oddments",
          status: true,
        },
        {
          label: "外协单位理论日产能",
          width: "160",
          prop: "outsourcingUnitCapacity",
          status: true,
        },
        { label: "负责人", width: "140", prop: "principalName", status: true },
        {
          label: "站点电话",
          width: "120",
          prop: "stationPhone",
          status: true,
        },
        {
          label: "试验单位",
          width: "120",
          prop: "testUnit",
          status: true,
        },
        {
          label: "更新时间",
          width: "135",
          prop: "updateTime",
          status: true,
        },
        // { label: "生产线", width: "130", prop: "", status: true },
        // { label: "使用仓", width: "130", prop: "", status: true },
        // { label: "库存仓", width: "130", prop: "", status: true },
        // { label: "浆水池", width: "130", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        code: [{ required: true, message: "请选输入站点编码", trigger: "change" }],
        dailyCapacity: [{ required: true, message: "请输入日产能", trigger: "change" }],
        stationAddress: [
          { required: true, message: "请输入站点地址", trigger: "change" },
        ],
        principalId: [{ required: true, message: "请选择负责人", trigger: "change" }],
        reconnaissanceAddress: [
          { validator: reconnaissanceAddressrules, trigger: "change" },
        ],
        stationPhone: [{ validator: landlinePhone, trigger: "change" }],
        oddments: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      fromDate: {
        electronicFence: "",
        company: "",
        companyId: "",
        stationId: "",
        stationName: "",
        dailyCapacity: "",
        stationAddress: "",
        longitude: "",
        dimensionality: "",
        outsourcingUnit: "",
        printOffset: 23,
        outsourcingUnitCapacity: "1",
        principalName: "",
        principalId: "",
        stationPhone: "",
        oddments: "",
        reconnaissanceAddress: "请选择地图标点",
        code: "",
        outsourcingUnitIds: [],
      },
      principalName: "",
      point: "",
      mapVisible: false,
      principalarr: [],
      /*公用数据*/
      id: "",
      list: [],

      /*生产线*/
      lineDialog: false,
      lineList: [],
      usewarehousearr: [],
      /*使用仓维护*/
      usewarehouseDialog: false,
      usewarehouseList: [],
      warehousearr: [],
      /*库存仓维护*/
      warehouseDialog: false,
      warehouseList: [],
      /*地图*/
      zoom: 14,
      mapCenter: [104.053317, 30.549161],
      events: {
        click: (e) => {
          _this.markers.position = [e.lnglat.lng, e.lnglat.lat];
          _this.getaddress(_this.markers.position);
        },
      },
      loaded: false,
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                alert(result);
                if (_this.fromDate.longitude !== "") {
                  _this.address = _this.fromDate.reconnaissanceAddress;
                  _this.mapCenter = [
                    _this.fromDate.longitude,
                    _this.fromDate.dimensionality,
                  ];
                  _this.markers.position = [
                    _this.fromDate.longitude,
                    _this.fromDate.dimensionality,
                  ];
                  _this.loaded = true;
                  _this.$nextTick();
                } else {
                  if (result && result.position) {
                    _this.lng = result.position.lng;
                    _this.lat = result.position.lat;
                    _this.mapCenter = [_this.lng, _this.lat];
                    _this.markers.position = [_this.lng, _this.lat];
                    _this.loaded = true;
                    _this.$nextTick();
                  }
                }
              });
            },
          },
        },
      ],
      address: "逸都国际",
      markers: {
        position: [104.045543, 30.53947],
        events: {
          dragend: (e) => {
            _this.markers.position = [e.lnglat.lng, e.lnglat.lat];
            _this.getaddress(_this.markers.position);
          },
        },
        draggable: true,
      },
      searchOption: {
        city: "四川省,重庆市",
        citylimit: true,
      },
      outsourcingUnitList: [],
      userarr: [],
      /*浆水池维护*/
      Dialog1: false,
      low: {},
      arr1: [],
      oldarr1: [],
      rowData: {},
      useHouseList: [],
      voiceList: [], // 接料语音数据
      stationList: [], //站点主体
      stations: [],
      stationfromDate: {
        page: 1,
        pageSize: 6,
        stationId: "",
      }, //站点主体form
      stationDialog: false, //站点主体dio\
      totalpage: 0,
      stationMainList: [],
      stationfromaddDate: {
        stationSubjectId: "",
        effectiveTime: "",
      },
      stationaddDialog: false,
      stationmainName: "",
      warehouseBindList: [],
      warehouseBindDig: false,
      stationLoad: false,
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      this.companylist = await permissionsCompanyList();
    } else {
      getUserAut("type").then((res) => {
        this.stationIdlist = res.data.pointList; //站点
        this.getStationIdlistFun(0, res.data.companyIds);
      });
    }

    this.principalarr = await orgUserTree("", 1);
    let params = {
      page: 1,
      pageSize: 100000,
    };
    querysupplierPage({ ...params, enable: 1, typeId: "0" }).then((res) => {
      this.outsourcingUnitList = res.data.data;
    });
    queryuserPage({ ...params, userEentrance: "entrance_manager" }).then((res) => {
      this.userarr = res.data.data;
    });
    this.treeData = await getPermissionsUserTree();
  },
  mounted() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, code: "", stationName: "" };
    this.gettableData();
  },
  methods: {
    lineCodeValidate(value, index) {
      const regex = /^L\d{3}$/;
      if (!regex.test(value)) {
        // 如果输入不匹配正则表达式，则清空输入值
        this.lineList[index].code = "";
        this.$message.warning("生产线编码格式只能为L+三位数字");
      }
    },
    selectUseHouse(value, index) {
      this.warehouseList[index]["userCodeList"] = [];
      value.forEach((item) => {
        let obj = this.useHouseList.find((item2) => item == item2.newValue);
        this.warehouseList[index]["userCodeList"].push({
          userCode: obj.code,
          lineId: obj.lineId,
        });
      });
    },
    /* 站点主体 */
    nextpage() {
      //站点主体翻页
      this.getmainstationlist(this.stationfromDate);
    },
    changeStationMain(row) {
      console.log(row);
      this.stationmainName = row.stationName;
      this.stationfromDate.stationId = row.stationId;
      this.stationDialog = true;
      this.getmainstationlist(this.stationfromDate);
    },
    addstations() {
      let station = this.companylist.find(
        (res) => res.id == this.stationfromaddDate.stationSubjectId
      );
      console.log(station);
      let item = {
        stationName: this.stationmainName,
        stationId: this.stationfromDate.stationId,
        stationSubject: station.name,
        stationSubjectId: station.id,
        effectiveTime: this.stationfromaddDate.effectiveTime,
      };
      this.addstationmain(item);
    },
    deleteStation(id) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          let data = { id: id, status: 0 };
          addStationMain(data).then((res) => {
            if (res.code == 1001) {
              this.stationfromDate.page = 1;
              this.getmainstationlist(this.stationfromDate);
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    getmainstationlist(params) {
      //获取站点主体列表
      // let result = await getStationMain(params);
      getStationMain(params).then((res) => {
        this.stationList = res.data.data;
        this.totalpage = res.data.totalRows;
      });
    },
    confrimaddstation() {
      //新增确认
    },
    addstationmain(data) {
      //新增站点主体
      addStationMain(data).then((res) => {
        console.log(res);
        let data = { page: 1, pageSize: 10, stationId: this.stationfromDate.stationId };
        this.getmainstationlist(data);
        if (res.code == 1001) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.codeMsg,
            type: "warning",
          });
        }
      });
    },

    /*地磅维护*/
    changeSite(row) {
      console.log(row);
      this.siteDig = true;
      this.$refs.siteMaintain.getSiteList(row);
    },
    addPoint() {
      this.addFromDate("添加");
      this.principalName = "";
      this.fromDate.stationId = this.UserInfo.pointIds[0];
      this.fromDate.stationName = this.UserInfo.pointName;
      this.fromDate.companyId = this.UserInfo.companyId;
      this.fromDate.company = this.UserInfo.companyName;
      this.fromDate.id = undefined;
    },
    barcodeBlur() {
      stationQueryCode({ code: this.fromDate.code, id: this.fromDate.id }).then((res) => {
        if (!res.data) {
          this.$message({
            message: "条码编码重复！",
            type: "warning",
          });
          this.fromDate.code = "";
        }
      });
    },
    /**逆向编码*/
    getaddress(lnglat) {
      let _this = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            _this.address = result.regeocode.formattedAddress;
            // result为对应的地理位置详细信息
          }
        });
      });
    },
    //地图初始化
    handleMapInit() {
      this.mapVisible = true;
      let _this = this;
      if (_this.fromDate.longitude !== "") {
        _this.address = _this.fromDate.reconnaissanceAddress;
        _this.mapCenter = [_this.fromDate.longitude, _this.fromDate.dimensionality];
        _this.markers.position = [
          _this.fromDate.longitude,
          _this.fromDate.dimensionality,
        ];
        _this.loaded = true;
        _this.$nextTick();
      } else {
        this.mapCenter = [104.065637, 30.657717];
        this.address = "逸都国际";
        this.markers.position = [104.065637, 30.657717];
        this.loaded = true;
      }
    },
    /**通过站点查询公司 */
    get_simple_organizationFun(id) {
      get_simple_organization({ id: id }).then((res) => {
        this.fromDate.companyId = res.data.id;
        this.fromDate.company = res.data.name;
      }); //查询站点所属公司
    },
    /**遍历公司查询站点组装并去重 */
    getStationIdlistFun(i, d) {
      console.log(d);
      if (i < d.length) {
        console.log("*****************");
        get_station_list({ parentId: d[i] }).then((res) => {
          res.data.forEach((v) => {
            this.stationIdlist.push({
              id: v.id,
              name: v.name,
            });
          });
          i++;
          /* 这里写了死循环，不知道有啥用 */
          // if (i < d.length) {
          //   this.getStationIdlistFun(i, d)
          // } else {
          //   let map = new Map();
          //   for (let item of this.stationIdlist) {
          //     if (!map.has(item.id)) {
          //       map.set(item.id, item);
          //     }
          //   }
          //   this.stationIdlist = [...map.values()];
          // }
        });
      } else {
        let map = new Map();
        for (let item of this.stationIdlist) {
          if (!map.has(item.id)) {
            map.set(item.id, item);
          }
        }
        this.stationIdlist = [...map.values()];
      }
    },
    /*根据公司获取站点*/
    setstationIdlist() {
      this.stationLoad = true;
      get_station_list({ parentId: this.fromDate.companyId }).then((res) => {
        this.stationIdlist = res.data;
        this.stationLoad = false;
      });
    },
    /*浆水池维护*/
    /*获取浆水池*/
    dialog(low) {
      this.low = low;
      getListByPid({ stationId: low.id }).then((res) => {
        this.arr1 = this.copy(res.data);
        this.oldarr1 = this.copy(res.data);
        this.Dialog1 = true;
      });
    },
    add1() {
      let item = {
        stationId: this.low.id,
        name: "",
        type: 1,
      };
      this.arr1.push(item);
    },
    delete1(index) {
      this.arr1.splice(index, 1);
    },
    saveStations() {
      //保存站点主体操作
      console.log(this.stationList);
    },
    /*保存*/
    submit1() {
      let allHasData = this.arr1.filter((item) =>
        this.oldarr1.some((items) => item.id == items.id)
      );
      allHasData.forEach((res) => {
        res.type = 2;
      });
      let deleteData = this.oldarr1.filter(
        (item) => !allHasData.some((items) => item.id == items.id)
      );
      deleteData.forEach((res) => {
        res.type = 0;
      });
      let addData = this.arr1.filter(
        (item) => !allHasData.some((items) => item.id == items.id)
      );

      let arr = [...allHasData, ...addData, ...deleteData];
      saveseriflux(arr).then((res) => {
        if (res.code * 1 === 1001) {
          this.$message.success("保存成功!!!");
          this.Dialog1 = false;
        }
      });
    },
    pagesupdateFromDate(data, text) {
      for (let key in this.fromDate) {
        this.fromDate[key] = data[key];
      }
      this.fromDate.outsourcingUnitIds =
        this.fromDate.outsourcingUnitIds?.split(",") || [];
      this.fromDate.outsourcingUnit = "";
      this.fromDate.principalId = data.principalId;
      this.fromDate.oddments = data.oddments;
      this.fromDate.stationId = data.id;
      this.fromDate.id = data.id;
      this.fromDate.electronicFence = data.electronicFence;
      this.addDialogTitle = text;
      this.setstationIdlist();
      this.addDialog = true;
      this.principalName = data.principalName;
      setTimeout(() => {
        this.$refs.reffromDate.clearValidate();
      }, 10);
    },
    downQRCode(data) {
      const params = {
        scene: `stationId=${data.stationId}`,
        page: "cooperator/pages/deliverygoods/index",
        width: "",
        autoColor: "",
        lineColor: "",
        isHyaline: "",
        appId: data.wxAppId,
      };
      this.$Download("/base/outer/no/login/getStationWxacode", params, data.stationName);
    },
    pagessubmitFromDate() {
      let _this = this;
      this.$refs.reffromDate.validate((valid) => {
        if (valid) {
          if (_this.fromDate.outsourcingUnitIds.length > 0) {
            let data = _this.outsourcingUnitList.filter((res) =>
              _this.fromDate.outsourcingUnitIds.some((items) => res.id == items)
            );
            let key = data.map((res) => {
              return res.name;
            });
            _this.fromDate.outsourcingUnit = key.join(",");
            _this.fromDate.outsourcingUnitIds = _this.fromDate.outsourcingUnitIds.join(
              ","
            );
          } else {
            _this.fromDate.outsourcingUnitIds = "";
          }
          // if (this.fromDate.electronicFence == 0 || this.fromDate.electronicFence > 2 || this.fromDate.electronicFence < 0) {
          //   this.$message({
          //     message: "电子围栏范围不能小于等于0或大于2KM!",
          //     type: "warning",
          //   });
          //   return;
          // }
          this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /*地图*/
    onSearchResult(pois) {
      let _this = this;
      if (pois.length > 0) {
        _this.address = pois[0].name;
        _this.markers.position = [pois[0].lng, pois[0].lat];
        _this.mapCenter = [pois[0].lng, pois[0].lat];
      }
    },
    savepoint() {
      this.fromDate.reconnaissanceAddress = this.address;
      this.fromDate.stationAddress = this.address;
      this.fromDate.longitude = this.markers.position[0];
      this.fromDate.dimensionality = this.markers.position[1];
      this.mapVisible = false;
    },
    /*重置数据*/
    init() {
      this.tableParam.code = "";
      this.tableParam.stationName = "";
      this.gettableData();
    },
    /*生产线*/
    changeline(data) {
      this.id = data.id;
      this.rowData = data;
      // 获取接料语音数据
      getDicType({ code: "receivingVoice" }).then((res) => {
        if (res && res.code === 1001) {
          this.voiceList = res.data.items || [];
        }
      });
      getPLByStationId({ stationId: data.id }).then((res) => {
        this.list = res.data.map((res) => {
          let obj = new Object();
          obj.id = res.id;
          obj.type = 2;
          obj.stationId = res.stationId;
          obj.code = res.code;
          obj.name = res.name;
          obj.output = res.output;
          obj.list = res.list.map((ress) => {
            let item = {
              id: ress.id, //获取时的id  //删除必传
              type: 2, //新增传1 不变传2 删除传0
              useBankId: ress.useBankId, //原物料id
            };
            return item;
          });
          return obj;
        });
        this.lineList = res.data.map((res) => {
          let obj = new Object();
          obj.id = res.id;
          obj.type = 2;
          obj.stationId = res.stationId;
          obj.code = res.code;
          obj.name = res.name;
          obj.accessControlCode = res.accessControlCode;
          obj.accessControlIp = res.accessControlIp;
          obj.output = res.output;
          obj.list = res.list.map((ress) => {
            let item = ress.useBankId;
            return item;
          });
          obj.receivingVoice = res.receivingVoice;
          obj.receivingVoiceId = res.receivingVoiceId;
          obj.receivingVoicePlace = res.receivingVoicePlace;
          obj.voiceObj = {
            receivingVoice: res.receivingVoice,
            receivingVoiceId: res.receivingVoiceId,
            receivingVoicePlace: res.receivingVoicePlace,
            id: res.receivingVoiceId,
          };
          console.log(res, obj, this.voiceList);
          return obj;
        });
      });
      warehousePage({ stationId: data.id }).then((res) => {
        this.usewarehousearr = res.data;
      });
      this.lineDialog = true;
    },
    selectVoice(e, i) {
      if (e) {
        this.lineList[i].receivingVoice = e.itemName || "";
        this.lineList[i].receivingVoiceId = e.id || "";
        this.lineList[i].receivingVoicePlace = e.itemValue || "";
      }
    },
    addline() {
      const data = {
        stationId: this.id,
        name: "",
        output: null,
        type: 1,
        list: [],
        accessControlIp: "",
        accessControlCode: "",
      };
      this.lineList.push(data);
    },
    Deleteline(index) {
      this.lineList.splice(index, 1);
    },
    saveline() {
      let str = this.copy(this.lineList);
      let data = this.lineContrast(str);
      let sum = 0;
      for (let i = 0; i < data.length; i += 1) {
        sum += data[i].output * 1;
      }
      if (sum > this.rowData.dailyCapacity * 1) {
        this.$message.warning("生产线日产能不能大于理论日产能");
        return;
      }
      data.voiceObj = undefined;
      saveOrUpdateProductLine(data).then((res) => {
        if (res.code === 1001) {
          this.resetOtherFromDate();
          this.$message.success("操作成功");
        }
      });
    },
    lineContrast(arr) {
      /*对比未操作的相同数据*/
      let allData = arr.filter((item) => this.list.some((items) => item.id == items.id));
      if (allData.length !== 0) {
        allData = allData.map((res) => {
          let val = this.list.find((item) => item.id == res.id).list;
          let allitems = val.filter((item) =>
            res.list.some((items) => item.useBankId == items)
          );
          let additems = res.list.filter(
            (item) => !allitems.some((items) => item == items.useBankId)
          );
          if (additems.length !== 0) {
            additems = additems.map((res) => {
              let obj = {
                type: 1, //新增传1 不变传2 删除传0
                useBankId: res, //原物料id
              };
              return obj;
            });
          }
          let deleteitems = val.filter(
            (item) => !allitems.some((items) => item.useBankId == items.useBankId)
          );
          if (deleteitems.length !== 0) {
            deleteitems.map((res) => {
              res.type = 0;
            });
          }
          res.list = [...allitems, ...additems, ...deleteitems];
          return res;
        });
      }
      let deleteData = this.list.filter(
        (item) => !allData.some((items) => item.id == items.id)
      );
      if (deleteData.length !== 0) {
        deleteData.map((res) => {
          res.type = 0;
        });
      }
      let addData = arr.filter((item) => !allData.some((items) => item.id == items.id));
      if (addData.length !== 0) {
        addData = addData.map((res) => {
          res.list = res.list.map((item) => {
            let obj = new Object();
            obj.useBankId = item;
            obj.type = 1;
            return obj;
          });
          return res;
        });
      }
      return [...allData, ...deleteData, ...addData];
    },
    //使用仓库存仓绑定/
    async warehouseBind(data) {
      this.id = data.id;
      let res = await wareusehousePage({ stationId: data.id });
      if (res.code == 1001) {
        this.usewarehouseList = res.data;
      }
      let res2 = await warehousePage({ stationId: data.id });
      if (res2.code == 1001) {
        this.warehouseList = res2.data;
      }
      let res3 = await getPLByStationId({ stationId: data.id });
      if (res3.code == 1001) {
        this.lineList = res3.data;
      }
      let res4 = await queryWarehouseUse({ stationId: data.id });
      if (res4.code == 1001) {
        this.warehouseBindList = res4.data;
      }
      this.warehouseBindDig = true;
    },
    saveusewarehouseBind() {
      let type = false;
      let typeIndex = 0;
      this.warehouseBindList.forEach((item, index) => {
        if (!item.warehouseId || !item.useLineId || !item.useCode || !item.useAliasName) {
          type = true;
          typeIndex = index + 1;
        }
      });
      if (type) {
        this.$message.warning(`第${typeIndex}行数据不完整！`);
        return;
      }
      let obj = {
        stationId: this.id,
        useList: this.warehouseBindList,
      };
      saveWarehouseUse(obj).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.warehouseBindDig = false;
        }
      });
    },
    /*使用仓*/
    async changeusewarehouse(data) {
      this.id = data.id;
      // await queryListsByStationId({ stationId: data.id }).then((res) => {
      //   this.warehousearr = res.data;
      // });
      await wareusehousePage({ stationId: data.id }).then((res) => {
        this.usewarehouseList = [
          {
            fixedName: "骨料仓1",
            name: null,
            code: "aggregateOne",
          },
          {
            fixedName: "骨料仓2",
            name: null,
            code: "aggregateTwo",
          },
          {
            fixedName: "骨料仓3",
            name: null,
            code: "aggregateThree",
          },
          {
            fixedName: "骨料仓4",
            name: null,
            code: "aggregateFour",
          },
          {
            fixedName: "骨料仓5",
            name: null,
            code: "aggregateFive",
          },
          {
            fixedName: "骨料仓6",
            name: null,
            code: "aggregateSix",
          },
          {
            fixedName: "骨料仓7",
            name: null,
            code: "aggregateSeven",
          },
          {
            fixedName: "骨料仓8",
            name: null,
            code: "aggregateEight",
          },
          {
            fixedName: "骨料仓9",
            name: null,
            code: "aggregateNine",
          },
          {
            fixedName: "骨料仓10",
            name: null,
            code: "aggregateTen",
          },
          {
            fixedName: "骨料仓11",
            name: null,
            code: "aggregateEleven",
          },
          {
            fixedName: "粉料仓1",
            name: null,
            code: "powderOne",
          },
          {
            fixedName: "粉料仓2",
            name: null,
            code: "powderTwo",
          },
          {
            fixedName: "粉料仓3",
            name: null,
            code: "powderThree",
          },
          {
            fixedName: "粉料仓4",
            name: null,
            code: "powderFour",
          },
          {
            fixedName: "粉料仓5",
            name: null,
            code: "powderFive",
          },
          {
            fixedName: "粉料仓6",
            name: null,
            code: "powderSix",
          },
          {
            fixedName: "粉料仓7",
            name: null,
            code: "powderSeven",
          },
          {
            fixedName: "粉料仓8",
            name: null,
            code: "powderEight",
          },
          {
            fixedName: "粉料仓9",
            name: null,
            code: "powderNine",
          },
          {
            fixedName: "外加剂仓1",
            name: null,
            code: "admixturesOne",
          },
          {
            fixedName: "外加剂仓2",
            name: null,
            code: "admixturesTwo",
          },
          {
            fixedName: "外加剂仓3",
            name: null,
            code: "admixturesThree",
          },
          {
            fixedName: "外加剂仓4",
            name: null,
            code: "admixturesFour",
          },
          {
            fixedName: "外加剂仓5",
            name: null,
            code: "admixturesFive",
          },
          {
            fixedName: "水仓1",
            name: null,
            code: "waterOne",
          },
          {
            fixedName: "水仓2",
            name: null,
            code: "waterTwo",
          },
          {
            fixedName: "水仓3",
            name: null,
            code: "waterThree",
          },
        ];
        if (res.data.length > 0) {
          this.usewarehouseList.forEach((v) => {
            let index = res.data.findIndex((dataV) => dataV.code == v.code);
            if (index != -1) {
              v.id = res.data[index].id;
              v.name = res.data[index].name;
              v.stationId = res.data[index].stationId;
              v.list = res.data[index].bvlist.map((ress) => {
                return ress.surplusBankId;
              });
            }
          });
          this.$forceUpdate();
        }
      });
      this.usewarehouseDialog = true;
    },
    Deleteusewarehouse(index) {
      this.usewarehouseList[index].name = null;
      this.usewarehouseList[index].list = [];
    },
    saveusewarehouse() {
      this.usewarehouseList.forEach((v) => {
        v.stationId = this.id;
      });
      wareusehousesaveOrUpdate(this.usewarehouseList).then((res) => {
        if (res.code === 1001) {
          this.$message.success("操作成功");
          this.resetOtherFromDate();
        }
      });
    },
    /*库存仓*/
    changewarehouse(data) {
      this.id = data.id;
      // getPLByStationId({ stationId: data.id }).then(res => {
      //   let resData = JSON.parse(JSON.stringify(res.data));

      //   wareusehousePage({ stationId: data.id }).then(res2 => {
      //     if (res2.code === 1001) {
      //       let arr = [];
      //       resData.forEach(item => {
      //         res2.data.forEach(item2 => {
      //           let obj = JSON.parse(JSON.stringify(item2));
      //           console.log(item.code);
      //           console.log(obj.fixedName);
      //           obj["lineCode"] = item.code;
      //           obj["lineName"] = item.name;
      //           obj["lineId"] = item.id;
      //           obj["newValue"] = item.id + "-" + obj.code;
      //           obj["newName"] = item.code + "-" + obj.fixedName + "/" + obj.name;
      //           arr.push(obj);
      //         });
      //       });
      //       console.log(arr);
      //       this.useHouseList = arr;
      //     }
      //   });
      // });

      warehousePage({ stationId: data.id }).then((res) => {
        this.list = res.data.map((res) => {
          let codeList = [];
          res.userCodeList?.forEach((item) => {
            codeList.push(item.lineId + "-" + item.userCode);
          });
          let obj = new Object();
          obj.id = res.id;
          obj.code = res.code;
          obj.type = 2;
          obj.codeList = codeList;
          obj.userCodeList = res.userCodeList;
          obj.weightShow = res.weightShow * 1 === 1;
          obj.sortNum = res.sortNum;
          obj.rawName = res.rawName;
          obj.stationId = res.stationId;
          obj.name = res.name;
          obj.stock = res.stock;
          obj.ledNum = res.ledNum;
          return obj;
        });
        let arr = this.copy(this.list);
        this.warehouseList = arr.map((res) => {
          let obj = new Object();
          obj.id = res.id;
          obj.code = res.code;
          obj.codeList = res.codeList;
          obj.userCodeList = res.userCodeList;
          obj.weightShow = res.weightShow;
          obj.sortNum = res.sortNum;
          obj.type = 2;
          obj.rawName = res.rawName;
          obj.stationId = res.stationId;
          obj.name = res.name;
          obj.stock = res.stock;
          obj.ledNum = res.ledNum;
          return obj;
        });
        this.warehouseDialog = true;
      });
    },
    addwarehouseBind() {
      const data = {
        warehouseId: "",
        useCode: "",
        useLineId: "",
        useAliasName: "",
        sortNum: "",
      };
      this.warehouseBindList.push(data);
    },
    deleteWarehouseBind(index) {
      this.warehouseBindList.splice(index, 1);
    },
    addwarehouse() {
      const data = {
        stationId: this.id,
        name: "",
        stock: null,
        type: 1,
      };
      this.warehouseList.push(data);
    },
    Deletewarehouse(index) {
      this.warehouseList.splice(index, 1);
    },
    savewarehouse() {
      /*数据外层对比，并集除去交集为添加删除数据，并集里没数据的list为修改或者无修改数据*/
      let str = this.copy(this.warehouseList);
      let data = this.dataContrast(str);
      const newData = data.map((item) => ({
        ...item,
        weightShow: item.weightShow ? 1 : 0,
        sortNum: item.sortNum * 1,
      }));
      warehousesaveOrUpdate(newData).then((res) => {
        if (res.code == 1001) {
          this.resetOtherFromDate();
          this.$message({
            message: "设置成功",
            type: "success",
          });
        }
      });
    },
    dataContrast(arr) {
      /*对比未操作的相同数据*/
      let allData = arr.filter((item) => this.list.some((items) => item.id == items.id));
      let deleteData = this.list.filter(
        (item) => !allData.some((items) => item.id == items.id)
      );
      if (deleteData.length !== 0) {
        deleteData.map((res) => {
          res.type = 0;
        });
      }
      let addData = arr.filter((item) => !allData.some((items) => item.id == items.id));
      if (addData.length !== 0) {
        addData = addData.map((res) => {
          return res;
        });
      }
      return [...allData, ...deleteData, ...addData];
    },
    resetOtherFromDate() {
      this.lineDialog = false;
      this.warehouseDialog = false;
      this.usewarehouseDialog = false;
      this.Dialog1 = false;
      this.stationDialog = false;
      this.warehouseBindDig = false;
      this.id = "";
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          // 有值了直接渲染
          resolve();
          return;
        }
        /**获取自己公司加权限组织树带人员的 */
        // 没有值根据当前父节点获取下面子节点并挂在树节点中，添加到对应父节点的children中
        getOrgznizationAndUsersTree(treeNode.dataRef.id).then((res) => {
          let children = res.data[0].children;
          this.diGui(children);
          treeNode.dataRef.children = children;
          this.$forceUpdate();
        });
        resolve();
      });
    },
    //递归判断是否是子节点
    diGui(arr) {
      if (arr.length > 0) {
        arr.forEach((res) => {
          if (res.children > 0) {
            this.diGui(res.children);
          } else {
            delete res.children;
            if (res.selectable == true) {
              res.isLeaf = true;
            }
          }
        });
      }
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}

.toolbar {
  padding-top: 10px;
}

.amap-page-container {
  position: relative;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.el-input,
.el-select,
.el-cascader {
  width: 200px;
}

.mapbutton {
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
}

.mapbutton:hover {
  border-color: $bg_color;
  cursor: pointer;
}

.amap-demo {
  height: 570px;
}

.bottomclass {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
<style>
.FZYplaceholder .ant-select-selection__placeholder {
  color: rgba(0, 0, 0, 0.65) !important;
}
</style>
